import React, { Component } from 'react';
import $ from 'jquery'; 

import { 
  Modal,
} from 'react-bootstrap/lib';
import 'fullcalendar/dist/fullcalendar.css';
//import 'fullcalendar/dist/fullcalendar.print.min.css';
import 'fullcalendar/dist/fullcalendar.js';
import './ReservationList.css';
import ReservationDetail from './ReservationDetail';
import {firebaseDb} from '../lib/firebase/firebase';
var SHA256 = require("crypto-js/sha256");

class ReservationList extends Component {
  constructor(props) {
    super(props);

    /*let test_events = [
      {
        id: 1,
        title: 'Event #1',
        start: (new Date()).toISOString(),
        editable: true,
      },
    ]*/

    this.state = {
      events:[],
      //events:test_events,
      showReservationModal: false,
      reservations:{},
    };
  }

  componentDidMount(){
    var _self = this;
    const { calendar } = this.refs;
    const { calendarMobile } = this.refs;
    var now = new Date();
    $(calendar).fullCalendar({
      events: function(start, end, timezone, callback) {
        callback(_self.state.reservations);
      },
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'listWeek,agendaDay,agendaWeek',//,month'
      },
      views: {
        listDay: { buttonText: 'day' },
        listWeek: { buttonText: 'list' }
      },
      selectable:true,
      select: function(start, end, jsEvent, view) {
          _self.props.onSelectDateRange && _self.props.onSelectDateRange({start:start.format(),end:end.format()})
      },
      /*validRange: function(nowDate) {
          return {
              start: nowDate,
          };
      },*/
      nowIndicator:true,
      defaultView: 'listWeek',
      defaultDate: (new Date()).toISOString(),
      navLinks: true, // can click day/week names to navigate views
      editable: this.props.editable,
      eventLimit: true, // allow "more" link when too many events
      eventClick: this.reservationClick.bind(this),
      dayClick: function(date, jsEvent, view) {
          console.log(date.format());
          console.log(jsEvent);
          console.log(view);
      },
      businessHours: [ // specify an array instead
          {
              dow: [ 1, 2, 3, 4, 5 ], // Monday, Tuesday, Wednesday
              start: '08:00', // 8am
              end: '18:00' // 6pm
          },
      ]      
    });

    $(calendarMobile).fullCalendar({
      events: function(start, end, timezone, callback) {
        callback(_self.state.reservations);
      },
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'listDay,agendaWeek',//,month'
      },
      views: {
        listDay: { buttonText: 'day' },
        listWeek: { buttonText: 'week' }
      },
      selectable:true,
      select: function(start, end, jsEvent, view) {
          _self.props.onSelectDateRange && _self.props.onSelectDateRange({start:start.format(),end:end.format()})
      },
      nowIndicator:true,
      /*validRange: function(nowDate) {
          return {
              start: nowDate,
          };
      },*/
      defaultView: 'listDay',
      defaultDate: (new Date()).toISOString(),
      navLinks: true, // can click day/week names to navigate views
      editable: this.props.editable,
      eventLimit: true, // allow "more" link when too many events
      eventClick: this.reservationClick.bind(this),
      dayClick: function(date, jsEvent, view) {
          console.log(date.format());
          console.log(jsEvent);
          console.log(view);
      },
      businessHours: [ // specify an array instead
          {
              dow: [ 1, 2, 3, 4, 5 ], // Monday, Tuesday, Wednesday
              start: '08:00', // 8am
              end: '18:00' // 6pm
          },
      ]      
    });

    firebaseDb.ref("reservations").orderByChild('venue').equalTo(this.props.selectedVenue).on('value',function(snap){
      var reservations = [];
      snap.forEach(function(child){
        var category = _self.props.categories&&_self.props.categories[child.val().category]?'  --  ' + _self.props.categories[child.val().category].name + '  -  ':"";
        var subCategory = _self.props.categories&&_self.props.categories[child.val().category] && _self.props.categories[child.val().category].sub_categories[child.val().sub_category]?_self.props.categories[child.val().category].sub_categories[child.val().sub_category].name:"";
        var asignee = _self.props.staff&&_self.props.staff[child.val().asignee]?_self.props.staff[child.val().asignee].name + '  --  ':"";
        var event = {
          id: child.key,
          title:  asignee + child.val().name + " " + category + " " + subCategory,
          start: child.val().start_datetime,
          end: child.val().end_datetime,
          editable: true,
          color:(child.val().color),
        }
        reservations.push(event);
      })
      _self.setState({reservations:reservations,reservationsData:snap.val(),loaded:true,},_self.renderCalendar.bind(_self))
    })

  }

  componentWillReceiveProps(nextProps){
    var _self = this;
    if(true){//nextProps.selectedVenue !== this.props.selectedVenue){
      firebaseDb.ref("reservations").orderByChild('venue').equalTo(this.props.selectedVenue).off()
      firebaseDb.ref("reservations").orderByChild('venue').equalTo(nextProps.selectedVenue).on('value',function(snap){
        var reservations = [];
        snap.forEach(function(child){
          var category = _self.props.categories&&_self.props.categories[child.val().category]?'  --  ' + _self.props.categories[child.val().category].name + '  -  ':"";
          var subCategory = _self.props.categories&&_self.props.categories[child.val().category] && _self.props.categories[child.val().category].sub_categories[child.val().sub_category]?_self.props.categories[child.val().category].sub_categories[child.val().sub_category].name:"";
          var asignee = _self.props.staff&&_self.props.staff[child.val().asignee]?_self.props.staff[child.val().asignee].name + '  --  ':"";
          var event = {
            id: child.key,
            title:  asignee + child.val().name + " " + category + " " + subCategory,
            start: child.val().start_datetime,
            end: child.val().end_datetime,
            editable: true,
            color:(child.val().color),
          }
          reservations.push(event);
        })
        _self.setState({reservations:reservations,reservationsData:snap.val(),loaded:true,},_self.renderCalendar.bind(_self))
      })

    }
  }

  editReservation(){

  }

  closeReservationModal() {
    this.setState({ showReservationModal: false });
  }

  openReservationModal(id) {
    var client_id = this.state.reservationsData[id].client;
    firebaseDb.ref('clients/' + client_id).once('value',function(snap){
      this.setState({ showReservationModal: true ,modalReservationId:id,modalReservationClient:snap.val()});
    }.bind(this))
  }

  reservationClick(calEvent, jsEvent, view) {
    console.log(calEvent);
    console.log('Coordinates: ' + jsEvent.pageX + ',' + jsEvent.pageY);
    console.log('View: ' + view);

    this.openReservationModal(calEvent.id)
  }

  renderCalendar(){
    const { calendar } = this.refs;
    $(calendar).fullCalendar( 'refetchEvents' )
  }

  render() {
    var modalContent = (
      <div>
        <Modal.Header closeButton>
          <Modal.Title>Reservation</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <h4>Overflowing text to show scroll behavior</h4>
          <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
        </Modal.Body>
      </div>
    );
    if(
      this.state.loaded  &&
      this.state.reservationsData &&
      this.state.reservationsData[this.state.modalReservationId]
    ){
      modalContent = (
        <div>
          <Modal.Body>
          <ReservationDetail 
            user={this.props.user}
            selectedVenue={this.props.selectedVenue}
            categories={this.props.categories}
            staff={this.props.staff}
            tags={this.props.tags}
            reservationId={this.state.modalReservationId}
            reservation={this.state.reservationsData[this.state.modalReservationId]} />
          </Modal.Body>
        </div>
      );
    }
    return (
      <div>
        <div className="hidden-sm hidden-xs" ref="calendar"></div>
        <div className="hidden-lg hidden-md" ref="calendarMobile"></div>

        <Modal show={this.state.showReservationModal} onHide={this.closeReservationModal.bind(this)}>
          {modalContent}
          <Modal.Footer>
            <button onClick={this.closeReservationModal.bind(this)} type="submit" className="btn btn-info pull-right">Close</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

// Specifies the default values for props:
ReservationList.defaultProps = {
  editable:false,
}
export default ReservationList;



// WEBPACK FOOTER //
// ./src/components/ReservationList.js